import { useCallback } from 'react';
import { OrgTypeWithRole } from 'src/@types/org';
import { Role } from 'src/@types/role';
import { mixpanelTrack } from 'src/utils/analytics';
import useApplyOrgSwitch, { useNavigateOrgHome } from 'src/hooks/useApplyOrgSwitch';

export default function useOrgSwitcherNavigation() {
  const applyOrgSwitch = useApplyOrgSwitch();
  const navigateOrgHome = useNavigateOrgHome();

  return useCallback(
    (org: OrgTypeWithRole, role: Role | undefined) => {
      // Writing these wakes the user's other tabs through the storage event,
      // which useSessionTabSync listens for.
      if (org.id) {
        localStorage.setItem('lastOrgId', org.id);
        localStorage.setItem('lastMode', org.managed_by_datatrust ? 'dt' : 'numinar');
      } else {
        localStorage.removeItem('lastOrgId');
        localStorage.removeItem('lastMode');
      }

      applyOrgSwitch(org.id ?? '', org.managed_by_datatrust ? 'dt' : 'numinar');

      mixpanelTrack('Switched Org', {
        org_id: [org?.id],
      });
      navigateOrgHome(role);
    },
    [applyOrgSwitch, navigateOrgHome]
  );
}
